<template>
  <div
    class="content"
    :class="{
      'electron-learning-center': isElectron,
      'learning-center': !isElectron,
    }"
  >
    <div class="tabs-wrap">
      <div v-if="!isElectron && isAuthenticated" class="user-info">
        <img class="avatar" :src="user.avatar" alt="头像" />
        <p class="name">{{ user.nickname }}</p>
      </div>
      <ul class="tabs-list">
        <li
          v-for="item in navList"
          :key="item.key"
          @click="handleClickTab(item)"
          :class="{ active: item.component.includes($route.name) }"
        >
          <div v-if="isElectron">
            <img
              v-if="item.component.includes($route.name)"
              class="active-icon"
              :src="item.activeImg"
              alt=""
            />
            <img v-else class="icon" :src="item.image" alt="" />
          </div>

          {{ isElectron ? item.name : item.pcName }}
        </li>
      </ul>
    </div>

    <div class="conten-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tabList from "../mixins/tab-list.js";
export default {
  mixins: [tabList],
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
  },
};
</script>

<style lang="scss" scoped>
.learning-center {
  padding: 30px 0 0;
  .tabs-wrap {
    position: fixed;
    float: left;
    width: 120px;
    background: var(--card-bg);
    border-radius: 18px;
    padding: 10px 0 12px;
    .user-info {
      width: 100px;
      height: 86px;
      background: var(--input-bg);
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin: 0 0 8px 10px;
    }
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-bottom: 8px;
    }
    .name {
      font-size: 16px;
      color: var(--text-primary);
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
      padding: 0 6px;
      text-align: center;
    }
    li {
      padding: 12px 12px 12px 24px;
      cursor: pointer;
      font-size: 16px;
      color: var(--text-secondary);
      line-height: 22px;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: var(--text-primary);
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 19px;
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        border-radius: 3px;
      }
    }
  }
  .conten-wrap {
    margin-left: 150px;
    // min-height: calc(100vh - #{$side-bar-width});
  }
}
.electron-learning-center {
  padding: 10px 0 0;
  .tabs-wrap {
    position: fixed;
    float: left;
    width: 100px;
    background: transparent;
    border-radius: 0;
    padding: 10px 0;
    li {
      display: flex;
      align-items: center;
      width: 80px;
      height: 30px;
      border-radius: 6px;
      padding-left: 10px;
      cursor: pointer;
      font-weight: 400;
      font-size: 14px;
      color: var(--text-secondary);
      line-height: 20px;
      &:hover {
        background: var(--input-bg);
      }
      margin-bottom: 10px;
      .active-icon,
      .icon {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
    .active {
      background: linear-gradient(
        132deg,
        rgba($color: #00eb81, $alpha: 0.3) 0%,
        rgba($color: #00c89d, $alpha: 0.3) 100%
      );
      color: var(--text-primary);
      &:hover {
        background: linear-gradient(
          132deg,
          rgba($color: #00eb81, $alpha: 0.3) 0%,
          rgba($color: #00c89d, $alpha: 0.3) 100%
        );
      }
    }
  }
  .conten-wrap {
    position: relative;
    margin-left: 110px;
    min-height: auto;
    &::after {
      top: 0;
      position: absolute;
      left: -15px;
      height: 100%;
      display: block;
      content: "";
      width: 1px;
      background: linear-gradient(
        180deg,
        rgba(250, 250, 251, 0) 0%,
        var(--user-btn-border) 5%,
        var(--user-btn-border) 95%,
        rgba(242, 244, 245, 0) 100%
      );
    }
  }
}
</style>
